/**
 * IGNIERE §80 Part 2: swatch モードのラベル配下に色名 <span> を挿入。
 *
 * core §80 Part 2 が `<span class="ig-swatch-name">{{ product_option_value }}</span>` を
 * swatch snippet の直後に描画していた。core 撤去後、Horizon 標準は色名を
 * `<span class="visually-hidden">` で a11y だけに晒すため、視覚上の色名テキストが消える。
 * それを DOM 上に復元するのが本モジュール。
 *
 * 対象: variant-picker 内で `.variant-option__button-label--has-swatch` を持つ label
 * 挿入: swatch snippet が出す `<span class="swatch">` の直後（core §80 Part 2 と同じ順序）
 * 冪等: data-ig80b="applied" マークで多重適用を防止。
 * 対応先の core 復元: snippets/variant-main-picker.liquid（既に upstream 復元済）。
 */
(function () {
  'use strict';
  const IG = window.IGNIERE_RUNTIME;
  if (!IG || !IG.register) return;

  IG.register('80b-swatch-name', {
    apply(root) {
      if (!root.querySelectorAll) return;
      const labels = root.querySelectorAll(
        '.variant-option__button-label--has-swatch:not([data-ig80b="applied"])'
      );
      for (const label of labels) {
        const input = label.querySelector('input[type="radio"]');
        if (!input) continue;
        // 挿入位置：swatch 要素の直後（無ければ label 末尾）
        const swatch = label.querySelector('.swatch');
        const name = document.createElement('span');
        name.className = 'ig-swatch-name';
        // §347：「Blue&Yellow」のように空白の無い名前は「&」の直後でだけ折れるようにする（語の途中で切らない）
        input.value.split('&').forEach((part, i, all) => {
          name.appendChild(document.createTextNode(part + (i < all.length - 1 ? '&' : '')));
          if (i < all.length - 1) name.appendChild(document.createElement('wbr'));
        });
        if (swatch && swatch.nextSibling) {
          label.insertBefore(name, swatch.nextSibling);
        } else if (swatch) {
          label.appendChild(name);
        } else {
          label.appendChild(name);
        }
        label.setAttribute('data-ig80b', 'applied');
      }
    },
  });
})();
